import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { AppError } from '@/shared/models'
import { modules } from './modules'

Vue.use(VueRouter)

var routes = [{ path: '*', redirect: '/home' }]

modules.forEach(module => {
  routes = routes.concat(module.routes)
})

const router = new VueRouter({
  mode: 'hash',
  //base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    // when navigating to a new route scroll to top
    return { x: 0, y: 0 }
  }
})

// see https://github.com/championswimmer/vuex-persist#how-to-know-when-async-store-has-been-replaced
const authGuard = async (to, from, next) => {

  // await store restoration
  await store.restored
  try {
    // await auth check
    const user = await store.dispatch('main/authCheck', to)
    if (!to.meta || !to.meta.authGuard || to.meta.authGuard(user)) { // user has access to route
      // procede
      next()
    } else {
      // access denied to route
      throw new AppError(`access denied to route '${to.name}' : user has not enough privileges`)
    }
  } catch (error) {
    if (to.meta && to.meta.authGuard) { // route needs authentication
      //store.commit('main/setAlert', error);

      // redirect to access-denied view
      next({
        name: 'access-denied',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  }
}
router.beforeEach(authGuard)

export default router

